<mat-sidenav-container class="app-container">
  <router-outlet></router-outlet>
  <div [ngClass]="isVisible ? 'visible-block' : 'hidden-block'">{{version}}</div>
</mat-sidenav-container>
